<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text" v-if="roleEditUser('pages')">
          Конструктор страниц
        </span>
        <span class="title-box-text" v-else> Аналитика и отчетность </span>
      </div>
      <v-btn v-if="roleEditUser('pages')" @click="dialog = true" style="width: auto !important" class="button-accept">
        + Добавить страницу
      </v-btn>
    </div>

    <div>
      <v-data-table :headers="tableHeaders" :items="items" :footer-props="{
        itemsPerPageOptions: [10, 25, 50],
        'items-per-page-text': '',
      }" class="elevation-0 main-table" :items-per-page="optionTable.itemsPerPage" :page="optionTable.page"
        @click:row="goToDetail" :server-items-length="optionTable.serverItemsLength" @pagination="tableChange"
        ref="sortableTable" fixed-header>
        <template v-slot:item.isMain="{ item }">
          <v-icon v-if="item.isMain && roleEditUser('pages')">mdi-star</v-icon>
        </template>
      </v-data-table>
      <v-dialog width="570px" height="auto" persistent v-model="dialog">
        <v-card width="570px" height="auto" class="rounded-0">
          <v-form ref="formFirst">
            <v-card-title class="dialog-title">
              <span class="title">Добавить страницу</span>
              <v-icon @mouseover="openInfo($event)" @mouseleave="showInfo = false" @click="closeDialog">mdi-close</v-icon>
            </v-card-title>
            <v-card-text class="dialog-description">
              <v-text-field style="margin-top: 20px" label="Название" required type="text" outlined :rules="rules"
                v-model="newPage.title"></v-text-field>
              <v-text-field label="Ключ" required type="text" outlined :rules="rules"
                v-model="newPage.key"></v-text-field>
            </v-card-text>
            <v-card-actions class="dialog-buttons">
              <v-btn style="width: 120px !important" @click="savePage" class="button-accept">
                Сохранить
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

export default {
  data: () => ({
    items: [],
    dialog: false,
    newPage: {},
    rules: [(value) => !!value || "Обязательно к заполнению"],
    tableHeaders: [
      {
        text: "",
        sortable: false,
        value: "isMain",
      },
      {
        text: "Название",
        value: "title",
        sortable: false,
      },
      {
        text: "Ключ",
        sortable: false,
        value: "key",
      },
    ],
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
  }),
  methods: {
    closeDialog() {
      this.dialog = false;
      this.newPage = {};
      this.$refs.formFirst.reset();
      this.$refs.formFirst.resetValidation();
    },
    savePage() {
      if (this.$refs.formFirst.validate()) {
        this.$axios
          .post(
            this.$store.getters.apiAdminPanelV2 + "/page",
            {
              title: this.newPage.title,
              key: this.newPage.key,
            },
            {
              headers: {
                authorization: this.$store.getters.adminPanelHeaderAuth,
              },
            }
          )
          .then(() => {
            this.closeDialog();
            this.getItems();
          })
          .catch((err) => {
            this.$store.commit("errorSet", true);
            this.$store.commit("errorTextSet", err);
          });
      }
    },
    checkLocal() {
      const localOptionTable = JSON.parse(
        localStorage.getItem("pagesOptionTable")
      );
      if (localOptionTable) {
        this.optionTable = localOptionTable;
      }
    },

    goToDetail(item) {
      this.$router.push({ name: "PageConstructor", params: { id: item.id } });
    },
    getItems() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/page/list",
          {
            optionTable: this.optionTable,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.optionTable = res.data.optionTable;
          this.items = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    tableChange(data) {
      this.optionTable.page = data.page;
      this.optionTable.itemsPerPage = data.itemsPerPage;
      localStorage.setItem(
        "pagesOptionTable",
        JSON.stringify(this.optionTable)
      );
      this.getItems();
    },
  },
  created() {
    this.getItems();
    this.checkLocal();
    if (!this.roleEditUser("pages")) {
      this.tableHeaders.shift();
    }
  },
};
</script>
<style lang="scss" scoped>
.main-table {
  height: calc(100vh - 195px) !important;
  min-height: calc(100vh - 195px) !important;
  max-height: calc(100vh - 195px) !important;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>